import React, { useEffect, useState, useMemo } from 'react'
import NavBar from '../Components/NavBar'
import { Link } from 'react-router-dom'
import rightbg from '../Images/right-bg.png'
import './Home.css'
import bgImage from '../Images/wm.png';
import sampleImg from '../Images/def.png'
import image2 from '../Images/image2.jpg'
import image3 from '../Images/bg-single-1.jpg'
import image4 from '../Images/1.jpg'

import image5 from '../Images/image4.jpg'
import image6 from '../Images/image6.jpg'
import image7 from '../Images/image5.jpg'

import logoWhite from '../Images/logo-white.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faTwitter, faInstagram, faLinkedin, faYoutube, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faArrowRight, faCaretRight } from '@fortawesome/free-solid-svg-icons'

import { getFirestore, collection, getDocs } from 'firebase/firestore'
import { app } from '../firebase'

function Home() {

  useEffect(() => {
    // 1. Page title
    document.title = "Zindua App | Influencer Marketing & Creator Monetisation Platform";

    // 2. Meta description
    let desc = document.querySelector("meta[name='description']");
    if (!desc) {
      desc = document.createElement("meta");
      desc.setAttribute("name", "description");
      document.head.appendChild(desc);
    }
    desc.setAttribute(
      "content",
      "Zindua App helps brands discover influencers, launch campaigns, run bulk promotions, and creators monetize their audience."
    );

    // 3. Open Graph tags (for social sharing)
    const ogTags = [
      { property: "og:title", content: "Zindua App | Influencer Marketing Platform" },
      { property: "og:description", content: "Connect brands with trusted influencers and help creators earn recurring income." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://zindua.app/" },
      { property: "og:image", content: "https://zindua.app/logo192.png" },
    ];

    ogTags.forEach(({ property, content }) => {
      let tag = document.querySelector(`meta[property='${property}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    });

    // 4. Structured data JSON-LD
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Zindua",
      url: "https://zindua.app",
      logo: "https://zindua.app/logo192.png",
      sameAs: [
        "https://www.instagram.com/zindua.app/",
        "https://www.linkedin.com/company/zindua-app/",
        "https://www.tiktok.com/@zindua.app"
      ],
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "+254795156925",
        contactType: "customer support",
        email: "hello@zindua.app"
      }
    });
    document.head.appendChild(script);

    // Cleanup function
    return () => {
      document.head.removeChild(script);
    };
  }, []);


  const facts = [
    { id: 1, number: '100+', label: 'Brands' },
    { id: 2, number: '1', label: 'Countries' },
    { id: 3, number: '50+', label: 'Influencers' },
  ];

  const db = getFirestore(app);
  const [influencers, setInfluencers] = useState([]);

  useEffect(() => {
    const fetchInfluencers = async () => {
      const querySnap = await getDocs(collection(db, "users"));
      const data = [];
      querySnap.forEach(doc => {
        const item = doc.data();
        if (item.userType === "An Influencer" && item.accountIsVerified) {
          data.push({ id: doc.id, ...item });
        }
      });

      // Shuffle the array randomly
      for (let i = data.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [data[i], data[j]] = [data[j], data[i]];
      }

      setInfluencers(data);
    };

    fetchInfluencers();
  }, [db]);





  return (
    <div>


      <div className='bg-mwitu'>
        <div className='container'>
          <NavBar />

          <section className='hero '>
            <div class="hero2-big-circle"></div>
            <div className='leftHero'>
              <h1 className='leftHeroH1'>Tell your Brand story with Influencer Marketing</h1>
              <p>Find the right Influencer for your brand and campaigns within your budget on your favourite platforms.</p>

              <div className='leftHerodiv'>
                <Link to="/register" className='btnSignUpHero'>Sign Up</Link>
                <Link to="/register" className='btnSignUpHero2'>Sign up as an influencer</Link>
              </div>

            </div>
            <div className='rightHero'>
              <div className='circleBg'>

              </div>
            </div>
            <img src={rightbg} className='rightbg1' alt="" />
          </section>

        </div>
      </div>



      <section>
        <div className="about-area" id="about">
          <div className="container">
            <div className="row align-items-center justify-content-between g-0 g-md-5">

              {/* About Cards Section */}
              <div className="col-12 col-lg-7">
                <div className="about-content">
                  <div className="row g-4 g-xl-5">

                    {/* Card 1 */}
                    <div className="col-12 col-sm-6">
                      <div className="card about-card">
                        <div className="card-body">
                          <div className="icon">
                            <svg
                              className="bi bi-app-indicator"
                              xmlns="http://www.w3.org/2000/svg"
                              width="32"
                              height="32"
                              fill="currentColor"
                              viewBox="0 0 16 16"
                            >
                              <path d="M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1H5.5z"></path>
                              <path d="M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"></path>
                            </svg>
                          </div>
                          <h5 className="mb-3">Discover Influencers & Creators</h5>
                          <p className="mb-0">
                            Find the right influencers and creators for your brand, browse their profiles, and check engagement metrics.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Card 2 */}
                    <div className="col-12 col-sm-6">
                      <div className="card about-card">
                        <div className="card-body">
                          <div className="icon bg-success text-white">
                            <svg
                              className="bi bi-lightbulb"
                              xmlns="http://www.w3.org/2000/svg"
                              width="32"
                              height="32"
                              fill="currentColor"
                              viewBox="0 0 16 16"
                            >
                              <path d="M3.05 3.05a7 7 0 0 0 0 9.9.5.5 0 0 1-.707.707 8 8 0 0 1 0-11.314.5.5 0 0 1 .707.707zm2.122 2.122a4 4 0 0 0 0 5.656.5.5 0 1 1-.708.708 5 5 0 0 1 0-7.072.5.5 0 0 1 .708.708zm5.656-.708a.5.5 0 0 1 .708 0 5 5 0 0 1 0 7.072.5.5 0 1 1-.708-.708 4 4 0 0 0 0-5.656.5.5 0 0 1 0-.708zm2.122-2.12a.5.5 0 0 1 .707 0 8 8 0 0 1 0 11.313.5.5 0 0 1-.707-.707 7 7 0 0 0 0-9.9.5.5 0 0 1 0-.707zM6 8a2 2 0 1 1 2.5 1.937V15.5a.5.5 0 0 1-1 0V9.937A2 2 0 0 1 6 8z" />
                            </svg>
                          </div>
                          <h5 className="mb-3">Run an Ad</h5>
                          <p className="mb-0">
                            Launch a campaign on your selected influencer’s platform within minutes. Set budget, duration, and ad materials easily.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Card 3 */}
                    <div className="col-12 col-sm-6">
                      <div className="card about-card">
                        <div className="card-body">
                          <div className="icon bg-warning text-white">
                            <svg
                              className="bi bi-bullseye"
                              xmlns="http://www.w3.org/2000/svg"
                              width="32"
                              height="32"
                              fill="currentColor"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                              <path d="M8 13A5 5 0 1 1 8 3a5 5 0 0 1 0 10zm0 1A6 6 0 1 0 8 2a6 6 0 0 0 0 12z" />
                              <path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" />
                              <path d="M9.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                            </svg>
                          </div>
                          <h5 className="mb-3">Run Bulk Campaigns</h5>
                          <p className="mb-0">
                            Launch a campaign across multiple creators and influencers simultaneously, set budgets, track performance, and maximize reach efficiently.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Card 4 */}
                    <div className="col-12 col-sm-6">
                      <div className="card about-card border-0 bg-primary">
                        <div className="card-body">
                          <div className="icon bg-info">
                            <svg
                              className="bi bi-lightbulb"
                              xmlns="http://www.w3.org/2000/svg"
                              width="32"
                              height="32"
                              fill="currentColor"
                              viewBox="0 0 16 16"
                            >
                              <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13a.5.5 0 0 1 0 1 .5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1 0-1 .5.5 0 0 1 0-1 .5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm6-5a5 5 0 0 0-3.479 8.592c.263.254.514.564.676.941L5.83 12h4.342l.632-1.467c.162-.377.413-.687.676-.941A5 5 0 0 0 8 1z" />
                            </svg>
                          </div>
                          <h5 className="mb-3 text-white">Creator Subscriptions</h5>
                          <p className="mb-0 text-white-50">
                            Explore creators’ service packages. Pick one or multiple monthly subscriptions to access exclusive services that help grow your brand and achieve your goals.
                          </p>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              {/* About Text Area */}
              <div className="col-12 col-sm-10 col-md-9 col-lg-5">
                <div className="section-heading mb-0 ms-xl-5">
                  <h6>Zindua App</h6>
                  <h2>Step into Creator Powered Marketing</h2>
                  <p>
                    Zindua App is a creator monetisation and influencer marketing platform that helps brands move beyond traditional advertising by working directly with creators who influence real purchasing decisions. Discover trusted influencers, launch targeted campaigns, run bulk promotions, and subscribe to creator services designed to deliver measurable growth for your brand.
                  </p>
                  <div className="about-btn-group mt-5">
                    <Link className="btnSignUpHero mt-5" to="/user/influencers">Run an Ad</Link>
                    <Link className="btnSignUpHero2 mt-5" to="/user/run-ads">Run bulk campaign</Link>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="cool-facts-wrapper">
          {/* Background Image */}
          <div className="cta-background-image">
            <img src={bgImage} alt="Background" />
          </div>

          {/* Background Circles */}
          <div className="circle-animation">
            <div className="circle1"></div>
            <div className="circle2"></div>
            <div className="circle3"></div>
            <div className="circle4"></div>
          </div>

          <div className="container">
            <div className="row justify-content-center mb-5">
              <div className="col-12 col-sm-10 col-md-9 col-lg-8 text-center">
                <div className="section-heading">
                  <h6>Some Milestones</h6>
                  <h2>Drive more revenue from influencer marketing</h2>
                </div>
              </div>
            </div>

            <div className="row g-4 justify-content-center">
              {facts.map((fact) => (
                <div key={fact.id} className="col-6 col-sm-4">
                  <div className="single-cool-fact wow fadeInUp">
                    <h2><span className="counter">{fact.number}</span></h2>
                    <h6 className="mb-0">{fact.label}</h6>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="saasbox-team-area pt-12 pb-120 bg-gradient" id="influencers">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-12 col-sm-9 col-md-7 col-lg-5">
                <div className="section-heading mb-lg-0">
                  <h6 className="text-dark">Influencers</h6>
                  <h2>Monetize Your Influence</h2>
                  <p className="text-dark">
                    Zindua App empowers creators to turn influence into income. Earn by running brand campaigns, offering subscription-based services, and collaborating with businesses that value your audience. Build recurring monthly income while doing what you do best.
                  </p>
                  <Link className="btn btn-light mt-5" to="/edit-profile">
                    Start Earning Today<i className="ms-3 bi bi-arrow-right"></i>
                  </Link>
                </div>
              </div>
              <div className="col-12 col-lg-7">
                <div className="team-members-area">
                  <div className="row justify-content-center g-4 g-xl-5">

                    {influencers.slice(0, 2).map((influencer, index) => (
                      <div key={influencer.id} className="col-12 col-sm-6">
                        <div
                          className={`card team-card wow fadeInUp`}
                          data-wow-duration="1000ms"
                          data-wow-delay={`${200 + index * 200}ms`}
                        >
                          <div className="card-body px-4 py-5 py-sm-4 py-md-5 text-center">
                            <div className="member-img mb-4 rounded-circle">
                              <img src={influencer.profileImage || sampleImg} alt={influencer.userName || "Influencer"} />
                            </div>
                            <h6>{influencer.userName || influencer.userName}</h6>
                            <p className="fz-14">{influencer.countryName || "Location not set"}</p>
                            <div className="border"></div>
                            <a
                              className={`mt-3 btn btn-${index % 2 === 0 ? "info" : "success"} btn-minimal fz-14`}
                              href={`/${influencer.theUsername}`}
                            >
                              View Profile <i className="bi bi-caret-right-fill"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    ))}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id='how-we-work'>
        <div className="about-area">
          {/* <div className="mb-120 b-block"></div> */}
          <div className="container">
            <div className="row g-5 align-items-center justify-content-md-center justify-content-lg-between">

              {/* About Thumbnail */}
              <div className="col-12 col-md-8 col-lg-6 col-xl-5">
                <div className="aboutUs-thumbnail">
                  <img
                    className="w-100"
                    src={image2}
                    alt=""
                  />
                </div>
              </div>

              {/* About Content */}
              <div className="col-12 col-md-8 col-lg-6">
                <div className="aboutUs-content">

                  <div className="section-heading mb-5">
                    <h6>Creator Monetization Platform</h6>
                    <h2>How Creators Earn on Zindua</h2>
                    <p>
                      Zindua App makes it easy for creators to get discovered, collaborate with brands, and earn consistently. Set up your profile, offer services, and start monetizing your influence through campaigns and subscriptions.
                    </p>
                  </div>

                  {/* Work Steps */}
                  <div className="work-step-wrapper">

                    <div className="single-work-step d-flex mb-4">
                      <span>1</span>
                      <div className="work-step-text">
                        <h6>Create Your Profile</h6>
                        <p>
                          Set up your creator profile, showcase your platforms, audience insights, and the services you offer. Brands can discover you based on relevance, engagement, and reach. You can also share your profile link across your social platforms to increase your outreach.
                        </p>

                      </div>
                    </div>

                    <div className="single-work-step d-flex mb-4">
                      <span>2</span>
                      <div className="work-step-text">
                        <h6>Offer Services & Subscriptions</h6>
                        <p>
                          Create service packages and monthly subscriptions that brands can subscribe to. Define what you offer, set your pricing, and start earning recurring monthly income.
                        </p>
                      </div>
                    </div>

                    <div className="single-work-step d-flex mb-4">
                      <span>3</span>
                      <div className="work-step-text">
                        <h6>Get Paid & Grow</h6>
                        <p>
                          Receive payments securely for campaigns and subscriptions. Track your performance, grow your audience, and build a sustainable creator income over time.
                        </p>
                      </div>
                    </div>



                  </div>

                  <Link className="btnSignUpHero" to="/register">
                    Get Started Today
                  </Link>

                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="cta-area position-relative">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-md-10 col-lg-8">
                <div className="cta-content text-center">
                  <h2>
                    Ready to grow your brand <br />
                    with Influencer Marketing?
                  </h2>
                  <p>
                    Connect with creators, launch campaigns, and track performance all in one place.
                  </p>

                  <Link to="/login" className="btnSignUpHero44">
                    Build your brand today
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Background Image */}
          <div className="cta-background-image2">
            <img
              src={image3}
              alt="CTA Background"
            />
          </div>
        </div>
      </section>

      <section>
        <div className="collaborate-area section-padding-120">
          <div className="container">
            <div className="row align-items-center justify-content-between">

              {/* Text Content */}
              <div className="col-12 col-md-6">
                <div className="collaborate-content">
                  <div className="section-heading mb-4">
                    <h6>Karibu!</h6>
                    <h2>Why Choose Zindua App</h2>
                    <p>
                      Zindua App is built to make creator marketing simple, predictable, and results-driven for both brands and creators. We go beyond one-off influencer deals by enabling long-term partnerships, transparent pricing, and measurable growth.
                    </p>
                  </div>

                  <ul className="collaborate-list">
                    <li>No platform access fees or hidden fees</li>
                    <li>Run campaigns within your budget from as low as KES 300</li>
                    <li>Smart creator discovery</li>
                    <li>Recurring monthly income for creators from subscriptions</li>
                    <li>Withdrwaw your earnings to M-Pesa</li>
                  </ul>

                  <Link
                    to="/register"
                    className="btnSignUpHero mt-4"
                  >
                    Karibu!
                  </Link>
                </div>
              </div>

              {/* Image Group */}
              <div className="col-12 col-md-6">
                <div className="cta-thumb-group">
                  <div className="row">

                    <div
                      className="col-4 wow fadeInUp"
                      data-wow-duration="1000ms"
                      data-wow-delay="100ms"
                    >
                      <img
                        src={image7}
                        alt=""
                      />
                    </div>

                    <div
                      className="col-4 wow fadeInDown"
                      data-wow-duration="1000ms"
                      data-wow-delay="300ms"
                    >
                      <img
                        src={image6}
                        alt=""
                      />
                    </div>

                    <div
                      className="col-4 wow fadeInUp"
                      data-wow-duration="1000ms"
                      data-wow-delay="500ms"
                    >
                      <img
                        src={image4}
                        alt=""
                      />
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <footer className="footer-area footer-2 pt-120 pb-120" id='contact-us'>
        <div className="container">
          <div className="row g-4 g-lg-5">

            {/* Footer Widget Area 1 */}
            <div className="col-12 col-sm-6 col-lg-3 fichahii">
              <div className="footer-widget-area">
                <Link className="d-block mb-4" to="/">
                  <img
                    style={{ height: "45px" }}
                    src={logoWhite}
                    alt=""
                  />
                </Link>
                <p>Data-driven Influencer Marketing platform.</p>
                <br />

                {/* Newsletter Form */}
                <div className="newsletter-form mb-4 ">
                  <form className="d-flex align-items-stretch" action="#">
                    <input
                      className="form-control rounded-0 rounded-start"
                      type="email"
                      placeholder="Enter email"
                    />
                    <button
                      className="btn btn-warning rounded-0 rounded-end px-3"
                      type="submit"
                    >
                      <FontAwesomeIcon icon={faArrowRight} />
                    </button>
                  </form>
                </div>
              </div>
            </div>

            {/* Footer Widget Area 2 */}
            <div className="col-12 col-sm-6 col-lg-3">
              <div className="footer-widget-area fichahii">
                <h5 className="mb-4 text-white">Features</h5>
                <ul className="list-unstyled">
                  <li>
                    <Link to="/user/influencers">
                      <FontAwesomeIcon icon={faCaretRight} />Discover Influencers
                    </Link>
                  </li>
                  <li>
                    <Link to="/user/run-ads">
                      <FontAwesomeIcon icon={faCaretRight} />Run Campaigns
                    </Link>
                  </li>
                  <li>
                    <Link to="/campaigns">
                      <FontAwesomeIcon icon={faCaretRight} />Manage Campaigns
                    </Link>
                  </li>
                  <li>
                    <Link to="/user/ads">
                      <FontAwesomeIcon icon={faCaretRight} />Campaign Analysis
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Footer Widget Area 3 */}
            <div className="col-12 col-sm-6 col-lg-3">
              <div className="footer-widget-area fichahii">
                <h5 className="mb-4 text-white">Pages</h5>
                <ul className="list-unstyled">
                  <li>
                    <a href="/" >
                      <FontAwesomeIcon icon={faCaretRight} />
                      Home
                    </a>
                  </li>
                  <li>
                    <a href="#about" >
                      <FontAwesomeIcon icon={faCaretRight} />
                      About Us
                    </a>
                  </li>
                  <li>
                    <a href="#how-we-work" >
                      <FontAwesomeIcon icon={faCaretRight} />
                      How We Work
                    </a>
                  </li>
                  <li>
                    <a href="#contact-us">
                      <FontAwesomeIcon icon={faCaretRight} />Contact us
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Footer Widget Area 4 */}
            <div className="col-12 col-sm-6 col-lg-3">
              <div className="footer-widget-area">
                <h5 className="mb-4 text-white">Contact Us</h5>
                <p className="lh-base mb-3">
                  4th Floor Paramount Plaza
                  <br /> Nairobi, Kenya
                </p>
                <p className="mb-0">
                  Call: 0795156925
                  <br /> Email: hello["@"]zindua.app
                </p>

                {/* Footer Social Icons */}
                {/* Footer Social Icons */}
                <div className="footer-social-icon d-flex align-items-center mt-3">
                  <a href="https://www.tiktok.com/@zindua.app" title="tiktok" target='_blank'>
                    <FontAwesomeIcon icon={faTiktok} />
                  </a>

                  <a href="https://www.instagram.com/zindua.app/" target='_blank' title="Instagram">
                    <FontAwesomeIcon icon={faInstagram} />
                  </a>

                  <a href="https://www.linkedin.com/company/zindua-app/" target='_blank' title="Linkedin">
                    <FontAwesomeIcon icon={faLinkedin} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Copywrite and Footer Nav */}
        <div className="container">
          <div className="copywrite-wrapper mt-5 rounded d-lg-flex align-items-lg-center justify-content-lg-between">

            {/* Copywrite Text */}
            <div className="copywrite-text text-center text-lg-start mb-3 mb-lg-0 me-lg-4">
              <p className="mb-0">{new Date().getFullYear()} &copy; Zindua Analytics. All rights reserved.</p>
            </div>

            {/* Footer Navigation */}
            <div className="footer-nav mb-3 mb-lg-0 me-lg-4">
              <ul className="mb-0 d-flex flex-wrap justify-content-center list-unstyled">
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-of-service" >Terms &amp; Conditions</Link>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </footer>

    </div>
  )
}

export default Home